import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-input__container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-input__error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "text-input__error-message"
}

import { PropType, ref } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import UmbracoFormInput from "@/components/umbraco-forms/inputs/UmbracoFormInput.vue";
import { InputState } from "@/models/umbraco-forms/InputState";
import { InputErrorState } from "@/models/umbraco-forms/InputErrorState";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormPassword',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {


const inputState = ref<InputState>(InputState.None);
const errorState = ref<InputErrorState>(InputErrorState.None);
const onStateChanged = (state: InputState) => {
  inputState.value = state;
};
const onInvalid = (state: InputErrorState) => {
  errorState.value = state;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-input", { 'text-input--active': !(inputState.value & _unref(InputState).Blurred) || !(inputState.value & _unref(InputState).Empty) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: __props.field.id
      }, _toDisplayString(__props.field.caption), 9, _hoisted_2),
      _createVNode(UmbracoFormInput, {
        field: __props.field,
        type: "password",
        onStateChanged: onStateChanged,
        onInvalid: onInvalid
      }, null, 8, ["field"])
    ]),
    (errorState.value & _unref(InputErrorState).Required)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.field.requiredErrorMessage), 1))
      : _createCommentVNode("", true),
    (errorState.value & _unref(InputErrorState).Pattern)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.field.patternInvalidErrorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})